import { Box, Typography, Stack, Link, Button, IconButton, List, ListItem, ListItemButton, DialogContent, Badge, Divider, ListItemDecorator, Input, FormLabel, Dropdown, MenuButton, Menu, Modal, ModalDialog, Textarea, RadioGroup, Radio } from "@mui/joy";
import { useTheme, useMediaQuery } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@mui/icons-material/Menu';
import DeleteIcon from '@mui/icons-material/Delete';
import { redirect, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Drawer from '@mui/joy/Drawer';
import DialogTitle from '@mui/joy/DialogTitle';
import ModalClose from '@mui/joy/ModalClose';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import { AccessTime, Add, Call, DeliveryDining, Discount, Email, GppGood, Info, KeyboardArrowDown, LocalOffer, Payment, Phone, Place } from "@mui/icons-material";
import { Transition } from "react-transition-group";
import OrderService from "./OrderService";

function Header() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openContact, setOpenContact] = useState(false);
    const [openDiscount, setOpenDiscount] = useState(false);
    const [cart, setCart] = useState([]);
    const [burger, setOpenBurger] = useState(false);
    const [checkoutStep, setCheckoutStep] = useState(1);
    const [customerDetails, setCustomerDetails] = useState({
        phone: '',
        name: ''
    });

    const priceOnRequestProductIds = new Set([5013, 5014, 5015])

    const getProductPriceLabel = (product) => {
        if (!product) return ""
        if (priceOnRequestProductIds.has(product.id)) return "Цена по запросу"
        return `${product.price} руб.`
    }

    const [paymentMethod, setPaymentMethod] = useState('Оплатить частями');

    const [helpName, setHelpName] = useState('');
    const [helpPhone, setHelpPhone] = useState('');
    const [helpMessage, setHelpMessage] = useState('');
    const [helpLoading, setHelpLoading] = useState(false);

    const callHelp = async (isDiscount = false) => {
        if (!helpName || !helpPhone || (!isDiscount && !helpMessage)) {
            alert('Все поля обязательны для заполнения.');
            return;
        }

        setHelpLoading(true);

        let message = isDiscount ? "Покупатель хочет получить скидку" : ("Заказан обратный звонок: " + helpMessage);

        var response = await OrderService.createCall(helpPhone, helpName, message);

        setHelpName('');
        setHelpPhone('');
        setHelpMessage('');
        setOpenContact(false);
        setOpenDiscount(false);
        setHelpLoading(false);

        alert(`Заявка на обратный звонок №${response.number} принята!`);
    }

    useEffect(() => {
        const loadCart = () => {
            try {
                const savedCart = localStorage.getItem('cart');
                if (savedCart) {
                    const parsedCart = JSON.parse(savedCart);
                    const validCart = parsedCart.filter(item => item.quantity > 0);
                    setCart(validCart);
                    if (validCart.length !== parsedCart.length) {
                        localStorage.setItem('cart', JSON.stringify(validCart));
                    }
                }
            } catch (error) {
                console.error('Error loading cart:', error);
                setCart([]);
            }
        };

        loadCart();
        window.addEventListener('cartUpdated', loadCart);
        window.addEventListener('openCart', () => setOpen(true));
        return () => {
            window.removeEventListener('cartUpdated', loadCart);
            window.removeEventListener('openCart', () => setOpen(true));
        };
    }, []);

    const removeFromCart = (productId) => {
        setCart(prevCart => {
            const newCart = prevCart.filter(item => item.id !== productId);
            localStorage.setItem('cart', JSON.stringify(newCart));
            window.dispatchEvent(new CustomEvent('cartUpdated', { detail: newCart }));
            return newCart;
        });
    };

    const updateQuantity = (productId, newQuantity) => {
        if (newQuantity <= 0) {
            removeFromCart(productId);
            return;
        }

        setCart(prevCart => {
            const newCart = prevCart.map(item =>
                item.id === productId ? { ...item, quantity: newQuantity } : item
            );
            localStorage.setItem('cart', JSON.stringify(newCart));
            window.dispatchEvent(new CustomEvent('cartUpdated', { detail: newCart }));
            return newCart;
        });
    };

    const handleQuantityChange = (productId, currentQuantity, isDecrease) => {
        if (isDecrease && currentQuantity === 1) {
            removeFromCart(productId);
        } else {
            updateQuantity(productId, isDecrease ? currentQuantity - 1 : currentQuantity + 1);
        }
    };

    const handleNextStep = () => {
        setCheckoutStep(2);
    };

    const handleBackStep = () => {
        setCheckoutStep(1);
    };

    const handlePayment = async () => {
        if (!customerDetails.phone || !customerDetails.name) {
            alert('Пожалуйста, заполните все поля');
            return;
        }

        if (customerDetails.phone.length < 7 || customerDetails.name.length < 2) {
            alert('Введите корректные данные');
            return;
        }

        let redirect_url = window.location.href;

        try {
            if (paymentMethod == 'Оплатить онлайн') {
                const response = await fetch('https://api.citruselectro.by/payment', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        totalAmount: calculateTotal(),
                        phone: customerDetails.phone,
                        name: customerDetails.name,
                        products: JSON.parse(localStorage.getItem('cart')).map(item => item.id)
                    }),
                });

                const data = await response.json();
                redirect_url = data.checkout.redirect_url;
            }
            else {
                var response = await OrderService.createCartOrder(customerDetails.phone, customerDetails.name, `Способ оплаты: ${paymentMethod}`, JSON.parse(localStorage.getItem('cart')));
                alert(`Заявка №${response.number} принята!`);
            }
        }
        catch (error) {
            console.error('Error calling payment script:', error);
            alert('An error occurred during payment processing.');
        }
        finally {
            localStorage.setItem('cart', []);
            window.location.href = redirect_url;
        }
    };

    const calculateTotal = () => {
        return cart
            .filter(item => !priceOnRequestProductIds.has(item.id))
            .reduce((total, item) => total + (item.price * item.quantity), 0)
            .toFixed(2);
    };

    return (
        <>
            <Box
                sx={{
                    position: 'sticky',
                    backgroundColor: '#ffffff',
                    height: '72px',
                    width: '100vw',
                    top: -1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0 20px',
                    gap: '20px',
                    zIndex: 999,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >

                <Stack direction="row" spacing={2} alignItems="center">
                    <Link
                        component="a"
                        underline="none"
                        onClick={() => navigate("/")}
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '24px',
                            color: '#FF0000',
                        }}
                    >
                        <img style={{ height: "32px" }} src="./img/logo.png" />
                    </Link>
                    {!isMobile && (
                        <>
                            <Link
                                component="a"
                                underline="none"
                                onClick={() => navigate("/catalog")}
                                sx={{
                                    color: 'gray',
                                    '&:hover': {
                                        color: '#FF0000',
                                    },
                                    '&:active': {
                                        color: '#FF0000',
                                    },
                                }}
                            >
                                Каталог
                            </Link>
                            <Link
                                component="a"
                                underline="none"
                                onClick={() => navigate("/payment")}
                                sx={{
                                    color: 'gray',
                                    '&:hover': {
                                        color: '#FF0000',
                                    },
                                    '&:active': {
                                        color: '#FF0000',
                                    },
                                }}
                            >
                                Оплата
                            </Link>
                            <Link
                                component="a"
                                underline="none"
                                onClick={() => navigate("/delivery")}
                                sx={{
                                    color: 'gray',
                                    '&:hover': {
                                        color: '#FF0000',
                                    },
                                    '&:active': {
                                        color: '#FF0000',
                                    },
                                }}
                            >
                                Доставка
                            </Link>
                            <Link
                                component="a"
                                underline="none"
                                onClick={() => navigate("/guarantee")}
                                sx={{
                                    color: 'gray',
                                    '&:hover': {
                                        color: '#FF0000',
                                    },
                                    '&:active': {
                                        color: '#FF0000',
                                    },
                                }}
                            >
                                Гарантия
                            </Link>
                            <Link
                                component="a"
                                underline="none"
                                onClick={() => navigate("/about")}
                                sx={{
                                    color: 'gray',
                                    '&:hover': {
                                        color: '#FF0000',
                                    },
                                    '&:active': {
                                        color: '#FF0000',
                                    },
                                }}
                            >
                                О нас
                            </Link>
                            <Link
                                component="a"
                                underline="none"
                                onClick={() => navigate("/contacts")}
                                sx={{
                                    color: 'gray',
                                    '&:hover': {
                                        color: '#FF0000',
                                    },
                                    '&:active': {
                                        color: '#FF0000',
                                    },
                                }}
                            >
                                Контакты
                            </Link>
                            <Link
                                component="a"
                                underline="none"
                                onClick={() => setOpenDiscount(true)}
                                sx={{
                                    color: 'gray',
                                    '&:hover': {
                                        color: '#FF0000',
                                    },
                                    '&:active': {
                                        color: '#FF0000',
                                    },
                                }}
                            >
                                Получить скидку
                            </Link>
                        </>
                    )}
                </Stack>

                <Stack direction="row" spacing={2} alignItems="center">
                    <Dropdown>
                        <MenuButton variant='plain' sx={{ p: 0, ":hover": { "& p, svg": { color: 'red' }, backgroundColor: 'transparent' }, ":active": { backgroundColor: 'transparent' } }}>
                            <Stack spacing={0.4} direction="row" sx={{ display: "flex", alignItems: "center" }}>
                                <Call sx={{ height: 18, width: 18, transition: 'color 0.1s' }} />
                                    <Typography sx={{ transition: 'color 0.1s' }} level='body-sm'>
                                        {!isMobile && ("+375 (17) 388-43-87")}
                                    </Typography>
                                    <KeyboardArrowDown sx={{ transition: 'color 0.1s' }} />
                            </Stack>
                        </MenuButton>
                        <Menu
                            variant="plain"
                            placement='bottom-end'
                            sx={{ borderRadius: 20, p: 2 }}>
                            <Stack spacing={1}>
                                <Stack direction="row" alignItems="flex-start" spacing={1}>
                                    <Call sx={{ pt: 0.3 }} />
                                    <Stack spacing={1}>
                                        <Stack>
                                            <Link underline="none" href="tel:+375173884387" color="danger" fontWeight="md">+375 (17) 388-43-87</Link>
                                            <Typography level="body-xs">Общий</Typography>
                                        </Stack>
                                        <Stack>
                                            <Link underline="none" href="tel:+375333124450" color="danger" fontWeight="md">+375 (33) 312-44-50</Link>
                                        </Stack>
                                        
                                    </Stack>
                                </Stack>

                                <Stack direction="row" alignItems="flex-start" spacing={1}>
                                    <Email sx={{ pt: 0.3 }} />
                                    <Link underline="none" href="mailto:bauwerkbuh@gmail.com" color="danger">
                                        bauwerkbuh@gmail.com
                                    </Link>
                                </Stack>

                                <Stack direction="row" alignItems="flex-start" spacing={1}>
                                    <AccessTime sx={{ pt: 0.3 }} />
                                    <Typography>с 9:00 до 21:00</Typography>
                                </Stack>

                                <Stack direction="row" alignItems="flex-start" spacing={1}>
                                    <Place sx={{ pt: 0.3 }} />
                                    <Typography>  
                                        Республика Беларусь, 220020, <br />
                                        г. Минск, ул. Тимирязева, д. 97, <br />каб. 22-24 
                                    </Typography>
                                </Stack>
                                <Button onClick={() => setOpenContact(true)} startDecorator={<Call sx={{ height: 20, width: 20 }} />} color='danger' size='lg' sx={{ borderRadius: 250 }}>Заказать звонок</Button>
                            </Stack>
                        </Menu>
                    </Dropdown>
                    <Badge
                        badgeContent={cart.reduce((total, item) => total + item.quantity, 0)}
                        color="danger"
                        badgeInset="2px 2px 0 0"
                        sx={{ "--Badge-ring": "none" }}
                        invisible={cart.length === 0}
                    >
                        <IconButton
                            onClick={() => { setOpen(true); setOpenBurger(false); }}
                            aria-label="Shopping Cart"
                            sx={{
                                borderRadius: 250,
                                color: '#333',
                                '&:hover': {
                                    color: '#FF0000',
                                },
                                '&:active': {
                                    color: '#FF0000',
                                },
                            }}
                        >
                            <ShoppingCartIcon />
                        </IconButton>
                    </Badge>

                    {isMobile && (
                        <IconButton
                            aria-label="Open Menu"
                            onClick={() => { setOpenBurger(!burger); if (burger) { setOpen(false); } }}
                            sx={{
                                borderRadius: 250,
                                color: '#333',
                                '&:hover': {
                                    color: '#FF0000',
                                },
                                '&:active': {
                                    color: '#FF0000',
                                },
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                </Stack>
            </Box>
            <Drawer
                sx={{
                    ".MuiDrawer-content": {
                        borderRadius: "20px 20px 0px 0px",
                        maxHeight: "80vh"
                    }
                }}
                size={isMobile ? 'lg' : 'md'}
                anchor="bottom"
                open={open}
                onClose={() => {
                    setOpen(false);
                    setCheckoutStep(1);
                }}
            >
                <ModalClose sx={{ borderRadius: 250 }} />
                <DialogTitle>Корзина</DialogTitle>
                <DialogContent sx={{ p: '12px', scrollbarWidth: "none" }}>
                    {!isMobile ? (
                        <Stack direction="row" spacing={2} sx={{ width: '100%', height: '100%' }}>
                            {/* Left side - Contact Form */}
                            <Box sx={{ width: '50%', pr: 2, height: '100%', pl: 1 }}>
                                <Stack spacing={1.5}>
                                    <Stack direction="column" spacing={0.25} sx={{ pb: 0.25 }}>
                                        <Typography level="h4" sx={{
                                            fontSize: '1.1rem',
                                            fontWeight: 600,
                                            color: '#FF0000'
                                        }}>
                                            Спасибо за ваш выбор!
                                        </Typography>
                                        <Typography level="body-md" sx={{
                                            fontSize: '0.8rem',
                                            color: 'text.secondary'
                                        }}>
                                            Заполните поля ниже для оформления заказа
                                        </Typography>
                                    </Stack>
                                    <Stack direction="column" spacing={1.5}>
                                        <Box sx={{ width: '100%' }}>
                                            <FormLabel sx={{
                                                mb: 1,
                                                fontSize: '0.8rem',
                                                fontWeight: 500
                                            }}>
                                                Ваше имя
                                            </FormLabel>
                                            <Input
                                                color="danger"
                                                placeholder="Иван Иванов"
                                                variant="outlined"
                                                sx={{
                                                    borderRadius: 20,
                                                    '&:hover': {
                                                        borderColor: '#FF0000',
                                                    },
                                                    '&:focus-within': {
                                                        borderColor: '#FF0000',
                                                    },
                                                    '& input': {
                                                        fontSize: '0.8rem',
                                                        py: 0.75
                                                    }
                                                }}
                                                value={customerDetails.name}
                                                onChange={(e) => setCustomerDetails(prev => ({ ...prev, name: e.target.value }))}
                                                required
                                            />
                                        </Box>
                                        <Box sx={{ width: '100%' }}>
                                            <FormLabel sx={{
                                                mb: 1,
                                                fontSize: '0.8rem',
                                                fontWeight: 500
                                            }}>
                                                Номер телефона
                                            </FormLabel>
                                            <Input
                                                color="danger"
                                                placeholder="+375 (XX) XXX-XX-XX"
                                                variant="outlined"
                                                sx={{
                                                    borderRadius: 20,
                                                    '&:hover': {
                                                        borderColor: '#FF0000',
                                                    },
                                                    '&:focus-within': {
                                                        borderColor: '#FF0000',
                                                    },
                                                    '& input': {
                                                        fontSize: '0.8rem',
                                                        py: 0.75
                                                    }
                                                }}
                                                value={customerDetails.phone}
                                                onChange={(e) => setCustomerDetails(prev => ({ ...prev, phone: e.target.value }))}
                                                required
                                            />
                                        </Box>
                                    </Stack>
                                </Stack>
                            </Box>

                            {/* Right side - Cart */}
                            <Box sx={{
                                width: '50%',
                                pl: 2,
                                borderLeft: '1px solid',
                                borderColor: 'divider',
                                height: '100%',
                                overflowY: 'auto',
                                '&::-webkit-scrollbar': {
                                    width: '6px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: 'transparent',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: '#FF0000',
                                    borderRadius: '3px',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                    background: '#cc0000',
                                }
                            }}>
                                {cart.length === 0 ? (
                                    <Typography>Похоже тут пусто</Typography>
                                ) : (
                                    <Stack spacing={1}>
                                        {cart.map((item) => (
                                            <React.Fragment key={item.id}>
                                                <Card sx={{ borderRadius: 20 }} variant="soft">
                                                    <CardContent>
                                                        <Stack direction="row" spacing={2} alignItems="center">
                                                            <img
                                                                src={item.image}
                                                                alt={item.name}
                                                                style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: 12 }}
                                                            />
                                                            <Box sx={{ flex: 1 }}>
                                                                <Typography level="title-sm">{item.name}</Typography>
                                                                <Stack sx={{ my: 1, display: "none" }} direction="row" spacing={1} alignItems="center">
                                                                    <IconButton
                                                                        size="sm"
                                                                        variant="soft"
                                                                        sx={{ borderRadius: 250 }}
                                                                        onClick={() => handleQuantityChange(item.id, item.quantity, true)}
                                                                    >
                                                                        -
                                                                    </IconButton>
                                                                    <Typography level="body-sm">{item.quantity}</Typography>
                                                                    <IconButton
                                                                        size="sm"
                                                                        variant="soft"
                                                                        sx={{ borderRadius: 250 }}
                                                                        onClick={() => handleQuantityChange(item.id, item.quantity, false)}
                                                                    >
                                                                        +
                                                                    </IconButton>
                                                                </Stack>
                                                                <Typography level="body-sm">{getProductPriceLabel(item)}</Typography>
                                                            </Box>
                                                            <IconButton
                                                                color="danger"
                                                                onClick={() => removeFromCart(item.id)}
                                                                sx={{ borderRadius: '250px' }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Stack>
                                                    </CardContent>
                                                </Card>
                                            </React.Fragment>
                                        ))}
                                    </Stack>
                                )}
                            </Box>
                        </Stack>
                    ) : (
                        checkoutStep === 1 ? (
                            <>
                                {cart.length === 0 ? (
                                    <Typography>Похоже тут пусто</Typography>
                                ) : (
                                    <>
                                        <Stack spacing={1}>
                                            {cart.map((item) => (
                                                <React.Fragment key={item.id}>
                                                    <Card sx={{ borderRadius: 20 }} variant="soft">
                                                        <CardContent>
                                                            <Stack direction="row" spacing={2} alignItems="center">
                                                                <img
                                                                    src={item.image}
                                                                    alt={item.name}
                                                                    style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: 12 }}
                                                                />
                                                                <Box sx={{ flex: 1 }}>
                                                                    <Typography level="title-sm">{item.name}</Typography>
                                                                    <Stack sx={{ my: 1, display: "none" }} direction="row" spacing={1} alignItems="center">
                                                                        <IconButton
                                                                            size="sm"
                                                                            variant="soft"
                                                                            sx={{ borderRadius: 250 }}
                                                                            onClick={() => handleQuantityChange(item.id, item.quantity, true)}
                                                                        >
                                                                            -
                                                                        </IconButton>
                                                                        <Typography level="body-sm">{item.quantity}</Typography>
                                                                        <IconButton
                                                                            size="sm"
                                                                            variant="soft"
                                                                            sx={{ borderRadius: 250 }}
                                                                            onClick={() => handleQuantityChange(item.id, item.quantity, false)}
                                                                        >
                                                                            +
                                                                        </IconButton>
                                                                    </Stack>
                                                                    <Typography level="body-sm">{getProductPriceLabel(item)}</Typography>
                                                                </Box>
                                                                <IconButton
                                                                    color="danger"
                                                                    onClick={() => removeFromCart(item.id)}
                                                                    sx={{ borderRadius: '250px' }}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Stack>
                                                        </CardContent>
                                                    </Card>
                                                </React.Fragment>
                                            ))}
                                        </Stack>
                                    </>
                                )}
                            </>
                        ) : (
                            <Stack spacing={3} sx={{ maxWidth: '100%' }}>
                                <Stack direction="column" spacing={0.25} sx={{ pb: 0.25 }}>
                                    <Typography level="h4" sx={{
                                        fontSize: '1.25rem',
                                        fontWeight: 600,
                                        color: '#FF0000'
                                    }}>
                                        Остался последний шаг!
                                    </Typography>
                                    <Typography level="body-md" sx={{
                                        fontSize: '0.875rem',
                                        color: 'text.secondary'
                                    }}>
                                        Заполните поля ниже для оформления заказа
                                    </Typography>
                                </Stack>
                                <Stack direction="column" spacing={1.5}>
                                    <Box sx={{ width: '100%' }}>
                                        <FormLabel sx={{
                                            mb: 1,
                                            fontSize: '0.875rem',
                                            fontWeight: 500
                                        }}>
                                            Ваше имя
                                        </FormLabel>
                                        <Input
                                            color="danger"
                                            placeholder="Иван Иванов"
                                            variant="outlined"
                                            sx={{
                                                borderRadius: 20,
                                                '&:hover': {
                                                    borderColor: '#FF0000',
                                                },
                                                '&:focus-within': {
                                                    borderColor: '#FF0000',
                                                },
                                                '& input': {
                                                    fontSize: '0.875rem',
                                                    py: 0.75
                                                }
                                            }}
                                            value={customerDetails.name}
                                            onChange={(e) => setCustomerDetails(prev => ({ ...prev, name: e.target.value }))}
                                            required
                                        />
                                    </Box>
                                    <Box sx={{ width: '100%' }}>
                                        <FormLabel sx={{
                                            mb: 1,
                                            fontSize: '0.875rem',
                                            fontWeight: 500
                                        }}>
                                            Номер телефона
                                        </FormLabel>
                                        <Input
                                            color="danger"
                                            placeholder="+375 (XX) XXX-XX-XX"
                                            variant="outlined"
                                            sx={{
                                                borderRadius: 20,
                                                '&:hover': {
                                                    borderColor: '#FF0000',
                                                },
                                                '&:focus-within': {
                                                    borderColor: '#FF0000',
                                                },
                                                '& input': {
                                                    fontSize: '0.875rem',
                                                    py: 0.75
                                                }
                                            }}
                                            value={customerDetails.phone}
                                            onChange={(e) => setCustomerDetails(prev => ({ ...prev, phone: e.target.value }))}
                                            required
                                        />
                                    </Box>
                                </Stack>
                            </Stack>
                        )
                    )}
                </DialogContent>
                <Box sx={{ p: 2, textAlign: isMobile ? 'none' : 'right' }}>
                    <Typography level="h4">
                        Итого: {calculateTotal()}{calculateTotal() > 0 && !cart.some(item => priceOnRequestProductIds.has(item.id)) ? ' руб.' : ''}
                    </Typography>
                    {checkoutStep === 1 && isMobile ? (
                        <Button
                            variant="solid"
                            color="danger"
                            fullWidth={isMobile}
                            disabled={cart.length === 0}
                            sx={{
                                mt: 2,
                                borderRadius: 250,
                                py: 1.5,
                                fontSize: '1rem',
                                fontWeight: 600,
                                '&:hover': {
                                    backgroundColor: '#cc0000'
                                }
                            }}
                            onClick={handleNextStep}
                        >
                            Далее
                        </Button>
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: isMobile ? 'column' : 'row',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                width: '100%'
                            }}
                        >
                            <Stack
                                direction="row"
                                spacing={2}
                                sx={{
                                    mt: 2,
                                    alignItems: 'flex-start',
                                    width: isMobile ? '100%' : 'auto',
                                }}
                            >
                                <RadioGroup
                                    orientation="horizontal"
                                    aria-labelledby="segmented-controls-example"
                                    value={paymentMethod}
                                    onChange={(event) => setPaymentMethod(event.target.value)}
                                    sx={{
                                        minHeight: 48,
                                        padding: '4px',
                                        borderRadius: '20px',
                                        bgcolor: 'neutral.softBg',
                                        '--RadioGroup-gap': '4px',
                                        '--Radio-actionRadius': '20px',
                                    }}
                                >
                                    {['Консультация', 'Оплатить частями'].map((item) => (
                                        <Radio
                                            key={item}
                                            color="neutral"
                                            value={item}
                                            disableIcon
                                            label={item}
                                            variant="plain"
                                            sx={{ px: 2, alignItems: 'center', fontSize: isMobile ? '10px' : '16px', textWrap: 'nowrap' }}
                                            slotProps={{
                                                action: ({ checked }) => ({
                                                    sx: {
                                                        ...(checked && {
                                                            bgcolor: 'background.surface',
                                                            boxShadow: 'sm',
                                                            '&:hover': {
                                                                bgcolor: 'background.surface',
                                                            },
                                                        }),
                                                    },
                                                }),
                                            }}
                                        />
                                    ))}
                                </RadioGroup>
                            </Stack>
                            <Stack
                                direction="column"
                                spacing={2}
                                sx={{
                                    mt: 2,
                                    alignItems: isMobile ? 'stretch' : 'flex-end',
                                    width: isMobile ? '100%' : 'auto',
                                }}
                            >
                                <Stack direction="row" spacing={2}>
                                    {isMobile && (
                                        <Button
                                            variant="outlined"
                                            color="neutral"
                                            fullWidth={isMobile}
                                            sx={{
                                                borderRadius: 250,
                                                py: 1.5,
                                                fontSize: '1rem',
                                                fontWeight: 600,
                                            }}
                                            onClick={handleBackStep}
                                        >
                                            Назад
                                        </Button>
                                    )}
                                    <Button
                                        variant="solid"
                                        color="danger"
                                        fullWidth={isMobile}
                                        sx={{
                                            borderRadius: 250,
                                            py: 1.5,
                                            fontSize: '1rem',
                                            fontWeight: 600,
                                            '&:hover': {
                                                backgroundColor: '#cc0000'
                                            }
                                        }}
                                        onClick={handlePayment}
                                    >
                                        Оформить заказ
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    )}
                </Box>
            </Drawer>

            <Drawer sx={{ zIndex: 998 }} open={burger} anchor="right" onClose={() => setOpenBurger(false)}>
                <DialogContent sx={{ pt: "72px", bgcolor: "#ffffff" }}>
                    <List>
                        <ListItem>
                            <ListItemButton onClick={() => { navigate("/catalog"); setOpenBurger(false); }}>
                                <ListItemDecorator><LocalOffer /></ListItemDecorator>
                                Каталог
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton onClick={() => { navigate("/payment"); setOpenBurger(false); }}>
                                <ListItemDecorator><Payment /></ListItemDecorator>
                                Оплата
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton onClick={() => { navigate("/delivery"); setOpenBurger(false); }}>
                                <ListItemDecorator><DeliveryDining /></ListItemDecorator>
                                Доставка
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton onClick={() => { navigate("/guarantee"); setOpenBurger(false); }}>
                                <ListItemDecorator><GppGood /></ListItemDecorator>
                                Гарантия
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton onClick={() => { navigate("/about"); setOpenBurger(false); }}>
                                <ListItemDecorator><Info /></ListItemDecorator>
                                О нас
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton onClick={() => { navigate("/contacts"); setOpenBurger(false); }}>
                                <ListItemDecorator><Phone /></ListItemDecorator>
                                Контакты
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton onClick={() => { setOpenBurger(false); setOpenDiscount(true); }}>
                                <ListItemDecorator><Discount /></ListItemDecorator>
                                Получить скидку
                            </ListItemButton>
                        </ListItem>
                    </List>
                </DialogContent>
            </Drawer>

            <Modal
                keepMounted
                open={openContact}
                onClose={() => setOpenContact(false)}
            >
                <ModalDialog
                    variant='plain'
                    sx={{
                        borderRadius: 20,
                        minWidth: !isMobile ? 480 : '80%',
                    }}
                >
                    <ModalClose sx={{ borderRadius: 250 }} />
                    <DialogTitle>Форма связи</DialogTitle>
                    <DialogContent>
                        <Stack spacing={1}>
                            <Stack spacing={1}>
                                <Typography>Ваше имя</Typography>
                                <Input
                                    value={helpName}
                                    onChange={(e) => setHelpName(e.target.value)}
                                    sx={{
                                        borderRadius: 20,
                                        outline: 'none',
                                        "&.Mui-focused": { "--Input-focusedHighlight": 'none' },
                                    }}
                                    placeholder="Иван Иванович..."
                                />
                            </Stack>
                            <Stack spacing={1}>
                                <Typography>Ваш номер телефона</Typography>
                                <Input
                                    pattern="[0-9+]+"
                                    value={helpPhone}
                                    type='text'
                                    onChange={(e) => setHelpPhone(e.target.value)}
                                    sx={{
                                        borderRadius: 20,
                                        outline: 'none',
                                        "&.Mui-focused": { "--Input-focusedHighlight": 'none' },
                                    }}
                                    placeholder="+375 (XX) XXX-XX-XX"
                                />
                            </Stack>
                            <Stack sx={{ pb: 1 }} spacing={1}>
                                <Typography>Сообщение</Typography>
                                <Textarea
                                    value={helpMessage}
                                    onChange={(e) => setHelpMessage(e.target.value)}
                                    sx={{
                                        borderRadius: 20,
                                        outline: 'none',
                                        "&.Mui-focused": { "--Textarea-focusedHighlight": 'none' },
                                    }}
                                    placeholder="Чем можем вам помочь?"
                                />
                            </Stack>
                            <Button onClick={() => callHelp()} loading={helpLoading} size='lg' color='danger' variant='solid' sx={{ borderRadius: 250 }}>
                                Заказать звонок
                            </Button>
                        </Stack>
                    </DialogContent>
                </ModalDialog>
            </Modal>

            <Modal
                keepMounted
                open={openDiscount}
                onClose={() => setOpenDiscount(false)}
            >
                <ModalDialog
                    variant='plain'
                    sx={{
                        borderRadius: 20,
                        minWidth: !isMobile ? 480 : '80%',
                    }}
                >
                    <ModalClose sx={{ borderRadius: 250 }} />
                    <DialogTitle>Получите персональную скидку!</DialogTitle>
                    <DialogContent>
                        <Stack spacing={1}>
                            <Stack spacing={1}>
                                <Typography>Ваше имя</Typography>
                                <Input
                                    value={helpName}
                                    onChange={(e) => setHelpName(e.target.value)}
                                    sx={{
                                        borderRadius: 20,
                                        outline: 'none',
                                        "&.Mui-focused": { "--Input-focusedHighlight": 'none' },
                                    }}
                                    placeholder="Иван Иванович..."
                                />
                            </Stack>
                            <Stack sx={{ pb: 1 }} spacing={1}>
                                <Typography>Ваш номер телефона</Typography>
                                <Input
                                    pattern="[0-9+]+"
                                    value={helpPhone}
                                    type='text'
                                    onChange={(e) => setHelpPhone(e.target.value)}
                                    sx={{
                                        borderRadius: 20,
                                        outline: 'none',
                                        "&.Mui-focused": { "--Input-focusedHighlight": 'none' },
                                    }}
                                    placeholder="+375 (XX) XXX-XX-XX"
                                />
                            </Stack>
                            <Button onClick={() => callHelp(true)} loading={helpLoading} size='lg' color='danger' variant='solid' sx={{ borderRadius: 250 }}>
                                Оставить заявку
                            </Button>
                        </Stack>
                    </DialogContent>
                </ModalDialog>
            </Modal>
        </>
    );
}

export default Header;

